import { FontUtils, LayoutUtils, MeshUtils, Rectangle3D, VirtualKeyboard3D, VirtualKeyboardUtils } from "@dreamcam/babylon-tools";
import { Env } from "../../../settings/Env";
import { DcRenderingGroup } from "../../DcRenderingGroup";
import { Observable } from "@babylonjs/core/Misc/observable.js";
import { Control } from "@babylonjs/gui/2D/controls/control.js";
import { XRInputHelper } from "../../XRInputHelper";
export var Keys;
(function (Keys) {
    Keys["enter"] = "\u21B5";
})(Keys || (Keys = {}));
export var TextKeyboardLayout;
(function (TextKeyboardLayout) {
    TextKeyboardLayout[TextKeyboardLayout["common"] = 0] = "common";
    TextKeyboardLayout[TextKeyboardLayout["login"] = 1] = "login";
})(TextKeyboardLayout || (TextKeyboardLayout = {}));
export class Keyboard3D {
    get onEnterButtonClickedObservable() {
        return this._onEnterButtonClickedObservable;
    }
    set onEnterButtonClickedObservable(value) {
        this._onEnterButtonClickedObservable = value;
    }
    get mesh2d() {
        return this._mesh2D;
    }
    get mesh() {
        return this._mesh2D.mesh;
    }
    // private readonly _colorButtonLayout: RectangleLayout;
    // private readonly _emojiButtonLayout: RectangleLayout;
    // private readonly _pagingButtonLayout: RectangleLayout;
    constructor(name, scene, guiParentNode, keyboardLayout = TextKeyboardLayout.common) {
        this.onVisibilityChange = new Observable(); // is visible argument
        this._lastActiveOwner = null;
        this._onEnterButtonClickedObservable = new Observable();
        this.width = Env.keyboard.width;
        this.height = Env.keyboard.height;
        this._keyboardLayout = keyboardLayout;
        this._mesh2D = MeshUtils.createPlaneMesh(name, this.width, this.height, scene, guiParentNode, DcRenderingGroup.aboveDialogs);
        this.rootControl = new Rectangle3D();
        this.rootControl.background = Env.keyboard.background;
        this.rootControl.cornerRadius = this._mesh2D.m2px(Env.keyboard.cornerRadius);
        this.rootControl.thickness = 0;
        this._mesh2D.texture.addControl(this.rootControl);
        this.control = new VirtualKeyboard3D(name);
        this.rootControl.addControl(this.control);
        const textButtonLayout = LayoutUtils.GetButtonLayout(Env.keyboard.buttonLayout, this._mesh2D);
        const emojiButtonLayout = LayoutUtils.GetButtonLayout(Env.keyboard.emojiButtonLayout, this._mesh2D);
        this.control.buttonLayout = textButtonLayout;
        const textLayout = FontUtils.getAdjustedFontStyle(Env.keyboard.textLayout, this._mesh2D);
        const emojiTextLayout = FontUtils.getAdjustedFontStyle(Env.keyboard.emojiTextLayout, this._mesh2D);
        this.control.textLayout = textLayout;
        // this.control.minButtonWidth = this._mesh2D.m2px(Env.keyboard.buttonWidth);
        // this.control.minButtonHeight = this._mesh2D.m2px(Env.keyboard.buttonHeight);
        this.control.spacing = this._mesh2D.m2px(Env.keyboard.verticalSpacing);
        this.control.horizontalSpacing = this._mesh2D.m2px(Env.keyboard.horizontalSpacing);
        this.control.verticalAlignment = Control.VERTICAL_ALIGNMENT_CENTER;
        this.control.cornerRadius = this._mesh2D.m2px(Env.keyboard.keyboardCornerRadius);
        let commonLayout, loginLayout, commonSymbolLayout, loginSymbolLayout = [];
        let emojiLayouts = [];
        let currentEmojiLayout = 0;
        const changeLayout = (keyboardLayout, buttonLayout, textLayout) => {
            this.control.changeLayout(keyboardLayout);
            this.control.buttonLayout = buttonLayout;
            this.control.textLayout = textLayout;
        };
        commonLayout = VirtualKeyboardUtils.GetAdjustedKeyboardLayout(Env.keyboard.commonLayout(() => changeLayout(commonSymbolLayout, textButtonLayout, textLayout), () => changeLayout(emojiLayouts[currentEmojiLayout], emojiButtonLayout, emojiTextLayout), () => this.onEnterButtonClickedObservable.notifyObservers()), this._mesh2D);
        commonSymbolLayout = VirtualKeyboardUtils.GetAdjustedKeyboardLayout(Env.keyboard.commonSymbolLayout(() => changeLayout(commonLayout, textButtonLayout, textLayout), () => changeLayout(emojiLayouts[currentEmojiLayout], emojiButtonLayout, emojiTextLayout), () => { this.onEnterButtonClickedObservable.notifyObservers(); }), this._mesh2D);
        loginLayout = VirtualKeyboardUtils.GetAdjustedKeyboardLayout(Env.keyboard.loginLayout(() => changeLayout(loginSymbolLayout, textButtonLayout, textLayout), () => { this.onEnterButtonClickedObservable.notifyObservers(); }), this._mesh2D);
        loginSymbolLayout = VirtualKeyboardUtils.GetAdjustedKeyboardLayout(Env.keyboard.loginSymbolLayout(() => changeLayout(loginLayout, textButtonLayout, textLayout), () => { this.onEnterButtonClickedObservable.notifyObservers(); }), this._mesh2D);
        emojiLayouts.push(VirtualKeyboardUtils.GetAdjustedKeyboardLayout(Env.keyboard.emojiLayout1(() => changeLayout(commonLayout, textButtonLayout, textLayout), () => { currentEmojiLayout = 1; changeLayout(emojiLayouts[currentEmojiLayout], emojiButtonLayout, emojiTextLayout); }, () => { currentEmojiLayout = 2; changeLayout(emojiLayouts[currentEmojiLayout], emojiButtonLayout, emojiTextLayout); }, () => { this.onEnterButtonClickedObservable.notifyObservers(); }), this._mesh2D), VirtualKeyboardUtils.GetAdjustedKeyboardLayout(Env.keyboard.emojiLayout2(() => changeLayout(commonLayout, textButtonLayout, textLayout), () => { currentEmojiLayout = 0; changeLayout(emojiLayouts[currentEmojiLayout], emojiButtonLayout, emojiTextLayout); }, () => { currentEmojiLayout = 2; changeLayout(emojiLayouts[currentEmojiLayout], emojiButtonLayout, emojiTextLayout); }, () => { this.onEnterButtonClickedObservable.notifyObservers(); }), this._mesh2D), VirtualKeyboardUtils.GetAdjustedKeyboardLayout(Env.keyboard.emojiLayout3(() => changeLayout(commonLayout, textButtonLayout, textLayout), () => { currentEmojiLayout = 0; changeLayout(emojiLayouts[currentEmojiLayout], emojiButtonLayout, emojiTextLayout); }, () => { currentEmojiLayout = 1; changeLayout(emojiLayouts[currentEmojiLayout], emojiButtonLayout, emojiTextLayout); }, () => { this.onEnterButtonClickedObservable.notifyObservers(); }), this._mesh2D));
        switch (this._keyboardLayout) {
            case TextKeyboardLayout.common:
                this.control.changeLayout(commonLayout);
                break;
            case TextKeyboardLayout.login:
                this.control.changeLayout(loginLayout);
                break;
        }
        XRInputHelper
            .addPointerAddon(this.mesh)
            .onPointerOut
            .add(() => this._mesh2D.notifyChildrenOnPointerOut());
        this.control.isHitTestVisible = true;
        this.control.isFocusInvisible = false;
    }
    setActiveOwner(ownerId) {
        this._lastActiveOwner = ownerId;
    }
    get lastActiveOwner() {
        return this._lastActiveOwner;
    }
    get isVisible() {
        return this._mesh2D.mesh.isVisible;
    }
    set isVisible(value) {
        if (this.isVisible === value)
            return;
        MeshUtils.setVisibility(this._mesh2D, value);
        if (!value) {
            this._lastActiveOwner = null;
        }
        this.onVisibilityChange.notifyObservers(value);
    }
    dispose() {
        this.control.dispose();
        this._mesh2D.dispose();
    }
}
